import {FC, useEffect} from "react";
import s from "./PersonalProfile.module.css"
import {useAppDispatch, useAppSelector} from "../../common/hooks/react-redux-hooks";
import {selectUserEmail, selectUserOrders} from "../../bll/selectors/userSelectors";
import {BackButton} from "../../common/components/Buttons/BackButton/BackButton";
import {PATH} from "../../common/utils/constants/constants";
import {getOrdersTC} from "../../bll/reducers/userReducer";
import {Order} from "./Order/Order";

export const PersonalProfile:FC = () => {
    const dispatch = useAppDispatch()
    const userDataOrders = useAppSelector(selectUserOrders)
    const userEmail = useAppSelector(selectUserEmail)
    const orders = userDataOrders.map(elem => <Order order={elem}/>)

    useEffect(() => {
        dispatch(getOrdersTC())
    })
    return (
        <section className={s.container}>
            <div className={s.backButton}>
                <BackButton name="В каталог" linkTo={PATH.CATALOG}/>
            </div>

            <div className={s.personalInfo}>
                {userEmail}
            </div>
            <div className={s.orders}>
                {orders}
            </div>
        </section>
    )
}